<template>
  <v-autocomplete
    v-model="breed"
    v-show-fade="{ isFilter: isFilter }"
    :data-test="dataTest"
    v-bind="$attrs"
    :items="masterBreeds"
    :label="
      $t(
        'horses:horseForm.input.Breed.label',
        'Breed',
        'Label of the breed field'
      )
    "
    :menu-props="menuProperties"
    item-value="id"
    item-text="name"
    outlined
    :clearable="clearable"
    :class="[selectMixinClass]"
    :hide-details="isFilter"
    @change="inputVisibility($event, 'change')"
    @focus="focused"
    @blur="inputVisibility"
  >
    <template #append-outer><slot name="append-outer"/></template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
import { useHorseBreedHelper } from "@composables/masterdata/breeds";
import selectMixin from "./selects_mixin";
export default defineComponent({
  name: "AppSelectBreeds",
  mixins: [selectMixin],
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    dataTest: {
      type: String,
      default: "breed"
    }
  },
  setup() {
    const { masterBreeds } = useHorseBreedHelper();
    return {
      masterBreeds
    };
  },
  data() {
    return {
      menuProperties: {
        minWidth: 280,
        closeOnContentClick: true
      }
    };
  },
  computed: {
    breed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
});
</script>
